import React from 'react';
export const AffirmRibbon = () => {
  return <div className="w-full bg-be-pink text-white py-4 flex justify-center items-center px-4 text-center" data-id="element-25">
      <p className="text-sm sm:text-base font-bold tracking-[0.15em] uppercase flex flex-wrap justify-center items-center gap-2" data-id="element-26">
        GET TREATED NOW + PAY LATER
        <span className="font-normal normal-case tracking-normal text-sm opacity-90 mx-2" data-id="element-27">
          —
        </span>
        <span className="font-normal normal-case tracking-normal text-sm opacity-90" data-id="element-28">
          Just select
        </span>
        <span className="font-bold italic normal-case tracking-normal text-lg mx-1" data-id="element-29">
          affirm
        </span>
        <span className="font-normal normal-case tracking-normal text-sm opacity-90" data-id="element-30">
          at checkout
        </span>
      </p>
    </div>;
};